/** Shared shape for APIs that bump draft form.version and return it to the client. */
export function attachFormVersion(entity, formVersion) {
  if (typeof formVersion === 'number') {
    entity.formVersion = formVersion;
  }

  return entity;
}
export function readFormVersion(entity) {
  if (!entity || typeof entity !== 'object') {
    return undefined;
  }

  var formVersion = entity.formVersion;
  return typeof formVersion === 'number' ? formVersion : undefined;
}